// Function to detect if text contains RTL characters (Hebrew or Arabic)
export const isRTL = (text) => {
    if (!text) return false;

    // Remove whitespace and punctuation for better accuracy
    const cleanText = text.replace(/[\s\p{P}]/gu, '');
    if (!cleanText) return false;

    // Count RTL characters
    const rtlRegex = /[\u0591-\u07FF\u200F\u202B\u202E\uFB1D-\uFDFD\uFE70-\uFEFC]/g;
    const rtlMatches = cleanText.match(rtlRegex) || [];
    const rtlCount = rtlMatches.length;

    // Calculate the percentage of RTL characters
    const rtlPercentage = (rtlCount / cleanText.length) * 100;

    // Return true if more than 50% of the text is RTL
    return rtlPercentage > 50;
};

// Function to get text direction style
export const getTextDirectionStyle = (text) => {
    const isRTLText = isRTL(text);
    return {
        direction: isRTLText ? 'rtl' : 'ltr',
        textAlign: isRTLText ? 'right' : 'left',
        fontFamily: isRTLText ?
            '"Noto Sans Arabic", "Noto Sans Hebrew", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif' :
            'inherit'
    };
}; 